import React from 'react';
import './Textbas-cdq.css';


const Textbas = () => {
    return (
        <div className="textbas-container">

                <div className="textbas-texts">
                    <p>
                     *Grace a l’implication du CDQ , le 2e Arrondissement de Port-Gentil se transforme chaque 
                    jour en un lieu plus sain,plus sur et plus agréable à vivre pour tous.*
                    </p>
                </div>
        </div>
           
    );
}

export default Textbas;